import _ from 'underscore';
import { getCenterCroppedSettings } from '@bingads-webui-campaign/image-experience-utils';
import { IImageExperienceImage, getMultiImages, IMTAsset } from '@bingads-webui-campaign-react/responsive-ad-editor-utils';
import { IRecommendAd, ResponsiveAdForPreview } from '../ad-recommend';

export function imageAssetcenterCrop(asset: IMTAsset) {
  const {
    SourceHeight,
    SourceWidth,
    SourceX,
    SourceY,
  } = getCenterCroppedSettings({
    SourceHeight: asset.CropHeight,
    SourceWidth: asset.CropWidth,
    SourceX: 0,
    SourceY: 0,
  }, 1.91);

  return {
    ...asset,
    CropX: SourceX,
    CropY: SourceY,
    CropWidth: SourceWidth,
    CropHeight: SourceHeight,
  };
}

export function convertRecommendAssetToImageExperience(ad: IRecommendAd, isMMAV2Enabled: boolean = false)
: IImageExperienceImage[][] {
  const imageToUrlMap = {};

  try {
    ad.Images.forEach((image) => {
      image.Asset.Id = !!image.Asset.Id ? image.Asset.Id : image.Asset.ImageUrl; // eslint-disable-line
      image.Asset.IdString = image.Asset.ImageUrl; // eslint-disable-line no-param-reassign
      image.Asset.SubType = isMMAV2Enabled ? 'OriginalImage' : 'LandscapeImageMedia'; // eslint-disable-line no-param-reassign

      imageToUrlMap[image.Asset.Id] = {
        url: image.Asset.ImageUrl,
        height: image.Asset.CropHeight,
        width: image.Asset.CropWidth,
        isRecommendedImage: true,
      };

      image.Asset = imageAssetcenterCrop(image.Asset); // eslint-disable-line no-param-reassign
    });

    return getMultiImages(
      ad.Images.map(image => image.Asset),
      imageToUrlMap,
      {
        isAdCreatorEnabled: false,
        isMMAV2Enabled,
      }
    );
  } catch (error) {
    console.error(error);
    return [];
  }
}

// imageListIndex: choose which ratio to display for preview
export function convertAdUnitsToImageExperiences(
  adUnits: IRecommendAd[],
  { imageListIndex }: { imageListIndex: number },
  isMMAV2Enabled: boolean = false
): IImageExperienceImage[] {
  const result: IImageExperienceImage[] = [];
  // deep clone ads
  const recommendAds: IRecommendAd[] = JSON.parse(JSON.stringify(adUnits));
  for (let i = 0; i < recommendAds.length; i += 1) {
    const ad = recommendAds[i];
    const item = convertRecommendAssetToImageExperience(ad, isMMAV2Enabled);

    if (item.length !== 0) {
      // display the ImageMedia178X100 image of each recommend ad
      result.push(item[0][imageListIndex]);
    }
  }

  return result;
}

export function convertAdunitsToImageList(adUnits: IRecommendAd[]): ResponsiveAdForPreview[] {
  const result: ResponsiveAdForPreview[] = [];
  // deep clone ads
  const recommendAds: IRecommendAd[] = JSON.parse(JSON.stringify(adUnits));
  for (let i = 0; i < recommendAds.length; i += 1) {
    const ad = recommendAds[i];
    const item = convertRecommendAssetToImageExperience(ad);

    result.push({
      images: item,
      shortHeadline: ad.Headline || _.get(ad.Headlines, ['0', 'Asset', 'Text']) as any,
      longHeadline: ad.LongHeadline || _.get(ad.LongHeadlines, ['0', 'Asset', 'Text']) as any,
      description: ad.Text || _.get(ad.Descriptions, ['0', 'Asset', 'Text']) as any,
      businessName: ad.BusinessName,
      url: _.first(ad.FinalUrls) as string,
    });
  }

  return result;
}
